export interface Address {
  id: number;
  name: string;
}

export const CountriesKey = 'countries';
export const StatesKey = 'states';
export const StatesWithCountryKey = 'states-with-country';
export const ZonesKey = 'zones';